import Cookies from 'js-cookie'
import Vue from 'vue'

const tokenKey = 'web_front_token'
const userInfoKey = 'web_front_user_info'
Vue.prototype.$getToken = () => { return Cookies.get(tokenKey) }
Vue.prototype.$setToken = (token) => { Cookies.set(tokenKey, token) }
Vue.prototype.$removeToken = () => { Cookies.remove(tokenKey) }

Vue.prototype.$getUserInfo = () => { return Cookies.get(userInfoKey) }
Vue.prototype.$setUserInfo = (userInfoString) => { Cookies.set(userInfoKey, userInfoString) }
Vue.prototype.$removeUserInfo = () => { Cookies.remove(userInfoKey) }

Vue.prototype.$getCookies = (key) => { return Cookies.get(key) }
Vue.prototype.$setCookies = (key, value) => { Cookies.set(key, value) }
Vue.prototype.$removeCookies = (key) => { Cookies.remove(key) }



// WEBPACK FOOTER //
// ./src/utils/cookies.js